const ipRegex = new RegExp(
  '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
)

const emailRegex = new RegExp('\\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Z|a-z]{2,}\\b')

const httpsUrlRegex = new RegExp('^https://(-\\.)?([^\\s/?\\.#-]+\\.?)+(/[^\\s]*)?$')

export { ipRegex, emailRegex, httpsUrlRegex }
